import { useState, useRef, useContext } from "react";
import { RequestLoader, ToastContext } from "../../../../hooks/context";
import { addMultipleCompositeProducts } from "../../../../services/inventory";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";
import { useImportCsv } from "../../../../hooks/useImportCsv";
import { useAddMultipleProducts } from "../../../../hooks/api/mutations/useInventory";

const AddMultipleProductsLogic = () => {
  const [option, setOption] = useState("single");
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const inputRef = useRef();
  const { formData, setFormData, handleSheetUpload } = useImportCsv({
    inputRef,
  });

  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const [errors, setErrors] = useState(null);
  const navigate = useNavigate();

  const { mutate: uploadProduct, isLoading: isCreatingProduct } =
    useAddMultipleProducts();

  const handleNormalBulkCreation = (xformData) => {
    uploadProduct(xformData, {
      onSuccess: () => {
        triggerToast(
          "Upload successfully. Note it might take 2 to 15 mins for all products to reflect",
          "success",
        );
        navigate(pathConstants.INVENTORY_PRODUCTS);
      },
      onError: (error) => {
        const errorsRes = error?.response?.data?.errors?.errors;

        if (errorsRes) setErrors(errorsRes);
      },
      onSettled: () => {
        inputRef.current.value = null;
      },
    });
  };

  const handleProductUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return triggerToast("Please select a file", "warning");

    if (event.target.files[0].size > 10000000)
      return triggerToast("File size should be less than 10mb", "warning");

    const xformData = new FormData();
    xformData.append("file", file);

    if (option === "single") return handleNormalBulkCreation(xformData);

    addMultipleCompositeProducts(xformData)
      .then(() => {
        navigate(pathConstants.INVENTORY_PRODUCTS);
        triggerToast("File uploaded successfully", "success");
      })
      .catch(() => {})
      .finally(() => {
        setIsUploadingFile(false);
        setRequestLoaderProgress(100);
        inputRef.current.value = null;
      });
  };

  return {
    isUploadingFile: isCreatingProduct || isUploadingFile,
    inputRef,
    option,
    formData,
    errors,
    setErrors,
    setOption,
    setFormData,
    handleSheetUpload,
    handleProductUpload,
  };
};

export default AddMultipleProductsLogic;
